<h2 mat-dialog-title>{{ "Lizenzen zusammenführen" | translate }}</h2>

<mat-dialog-content>
  <p>{{ "Welche Lizenz soll die Hauptlizenz bleiben?" | translate }}</p>
  <mat-radio-group [(ngModel)]="primaryGuid" class="radio-group">
    <div class="licence-choice" *ngFor="let lic of [data.licenceA, data.licenceB]">
      <mat-radio-button [value]="lic.guid">
        <span class="licence-label">{{ labelFor(lic) }}</span>
        <mat-icon
          *ngIf="hasBase(lic.guid)"
          class="base-badge"
          [matTooltip]="'Basislizenz' | translate"
          >workspace_premium</mat-icon
        >
      </mat-radio-button>

      <div class="options" *ngIf="!optionsLoading">
        <ng-container *ngIf="optionsFor(lic.guid).length; else noOptions">
          <span
            class="option-chip"
            *ngFor="let opt of optionsFor(lic.guid)"
            [class.is-base]="opt.isBase"
          >
            <mat-icon>{{ opt.isBase ? 'workspace_premium' : opt.icon }}</mat-icon>
            <span>{{ opt.name }}</span>
          </span>
        </ng-container>
        <ng-template #noOptions>
          <span class="no-options">{{ "Keine Optionen" | translate }}</span>
        </ng-template>
      </div>
    </div>
  </mat-radio-group>

  <div class="options-loading" *ngIf="optionsLoading">
    <mat-spinner [diameter]="20"></mat-spinner>
    <span>{{ "Optionen werden geladen…" | translate }}</span>
  </div>

  <p class="hint">
    {{ "Die andere Lizenz wird archiviert. Ihre SMAs bleiben erhalten und können über diesen Dialog wieder getrennt werden." | translate }}
  </p>

  <div class="merge-blocked" *ngIf="mergeBlocked">
    <mat-icon>block</mat-icon>
    <span>{{ blockReason | translate }}</span>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">{{ "Cancel" | translate }}</button>
  <button mat-flat-button color="primary" [disabled]="merging || mergeBlocked" (click)="merge()">
    <mat-icon>merge</mat-icon>
    {{ "Zusammenführen" | translate }}
  </button>
</mat-dialog-actions>
